import { MaskToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { AddImageButton } from './components/AddImageButton'
import { CopyButton } from '../components/CopyButton/CopyButton'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const MaskToolbar = track(({ editor, shapeId }: MaskToolbarProps) => {
  const shape = editor.getShape<MaskShape>(shapeId)
  const { isMobile } = useResponsiveDesign()

  return (
    <Toolbar>
      {shape && !isMobile && <AddImageButton editor={editor} selectedShape={shape} />}
      <CopyButton />
      <DeleteButton />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { MaskToolbar }
